<template>
<PLayout>
  <PLayoutSection>
  <PBanner v-if="!appData || appData.status!=='accepted'" fullWidth status="warning" title="The Salespopup will not be displayed to customers if there are over 100 daily sessions!"><PButton primary @click="this.loadingstateb = true" :loading="loadingstateb" :href="`https://us-central1-sales-boosting-bb.cloudfunctions.net/appcharge`+ `?shop=` + this.$route.query.shop + `&myAuth=` + this.$route.query.myAuth" textAlign="center" size="large" style="margin-top:25px; background: transparent; border-color: #8c9196; box-shadow: none; color: #202223; position: relative;">Upgrade to PREMIUM</PButton></PBanner>
  </PLayoutSection>
  <PLayoutSection>

  <NewLineChart :chart-data="chartData"/>
  <!---<line-chart :chart-data="chartData" style="max-height:420px"></line-chart> -->
  </PLayoutSection>
  <PLayoutSection secondary>
      <PLayout sectioned>
        <PCard v-for="item in items" :key="item" :title="item.title" sectioned>
        <b style="font-size:25px">{{item.attributeThree}}</b>
        </PCard> 
      </PLayout>
      <PLayout sectioned>
        <PButton v-if="appData && appData.status==='accepted'" @click="$router.push('payment')" primary fullWidth textAlign="center" size="large" class="button_styling">PREMIUM Settings</PButton>      
        <PButton v-else primary fullWidth @click="loadingstate = true" :loading="loadingstate" :href="`https://us-central1-sales-boosting-bb.cloudfunctions.net/appcharge`+ `?shop=` + this.$route.query.shop + `&myAuth=` + this.$route.query.myAuth" textAlign="center" size="large" class="button_styling">Upgrade to PREMIUM</PButton>
      </PLayout>
  </PLayoutSection>
</PLayout>
</template>

<script>
import {db, FieldPath} from '@/firebase'
import {generateUTCDateString} from '@/analytics'
// import LineChart from './LineChart.js'
import NewLineChart from '@/components/NewLineChart'

export default {
  name: "Analytics",
  components: {
    // LineChart,
    NewLineChart
  },
  props: {
    msg: String,
  },
  data() { return {
    today: {},
    pastDays: [],
    datacollection: null,
    appData: {},
    loadingstate: false,
    loadingstateb: false,
  }},
  async created() {
          const data = await db.collection('shops').doc(this.$route.query.shop).collection('appcharge').doc('data').get()
          this.appData = data.data() 
  },
  computed: {
    items(){
      return [
                        {
                            url: '#',
                            title: `Today's Sessions`,
                            attributeOne: 'Sessions',
                            attributeTwo: '',
                            attributeThree: (this.today.sessions || 0).toString(),
                        },
                        {
                            url: '#',
                            title: `Today's Clicks`,
                            attributeOne: 'Clicks',
                            attributeTwo: '',
                            attributeThree: (this.today.clicks || 0).toString(),
                        },
                    ]
    },

    last7days(){
      let now = new Date()
      let days = []
      for(let i = 0; i < 7; i++){
        days.push(generateUTCDateString(new Date(now.getTime()-i*1000*60*60*24)))
      }
      return days.reverse()
    },

    data7days(){
      return this.last7days.map(
        (d) => this.pastDays.find((doc)=>doc.id == d)
      )
    },

    chartData(){
      return {
        labels: this.last7days,
        datasets: [
          {
              label: 'Clicks',
              backgroundColor: '#EEC200',
              data: this.data7days.map((d)=>(d||{}).clicks || 0)
            }, {
              label: 'Sessions',
              backgroundColor: '#5c6ac4',
              data: this.data7days.map((d)=>(d||{}).sessions || 0)
            }
        ]
      }
    }
  },
  mounted(){
    this.loadingstate = false
    this.loadingstateb = false
    this.fillData()
    //console.log(`/shops/${this.$route.query.shop}/analytics/default/days/${generateUTCDateString(new Date())}`)
    this.$bind('today', db.doc(`/shops/${this.$route.query.shop}/analytics/default/days/${generateUTCDateString(new Date())}`))
    this.$bind('pastDays', db.collection(`/shops/${this.$route.query.shop}/analytics/default/days`).where(FieldPath.documentId(), 'in', this.last7days))
  },
      methods: {
      loadingtrue () {
        this.loadingstate = true
      },
      fillData () {
        this.datacollection = {
          labels: [this.getRandomInt(), this.getRandomInt()],
          datasets: [
            {
              label: 'Data One',
              backgroundColor: '#f87979',
              data: [this.getRandomInt(), this.getRandomInt()]
            }, {
              label: 'Data One',
              backgroundColor: '#f87979',
              data: [this.getRandomInt(), this.getRandomInt()]
            }
          ]
        }
      },
      getRandomInt () {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.button_styling{
  margin-top:25px; 
  color: white
}
</style>
